import React, { type FunctionComponent } from 'react'
import { useBooleanState } from '@retailer-platform/shared-components'
import { Button, type ButtonProps } from '@retailer-platform/shared-components/src/tds'
import {
  ActivityHistoryModal,
  type ActivityHistoryProps,
} from '../activity-history/ActivityHistory'
import { useDomainMessages } from '../../utils/domain/intl'

export type ViewHistoryButtonProps = ActivityHistoryProps & {
  buttonProps?: ButtonProps
}

export const ViewHistoryButton: FunctionComponent<ViewHistoryButtonProps> = ({
  ar,
  buttonProps = {},
  ...rest
}) => {
  const [isModalOpen, setModalOpen, setModalClosed] = useBooleanState()

  const i18n = useDomainMessages({
    viewHistory: 'approvalManagementLibrary.viewHistory',
  })

  return (
    <>
      <ActivityHistoryModal
        ar={ar}
        {...rest}
        isOpen={isModalOpen}
        onRequestClose={setModalClosed}
      />
      <Button name="viewHistory" onClick={setModalOpen} variant="secondary" {...buttonProps}>
        {i18n.viewHistory}
      </Button>
    </>
  )
}
